import { inject } from '@angular/core';
import { Route } from '@angular/router';
import {
  AdminRole,
  authGuard,
  CurrentUserService,
  roleGuard,
} from '@tnq/shared/core';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [authGuard('auth')],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'admins',
      },
      {
        path: '',
        loadComponent: () =>
          import('@tnq/shared/ui').then((c) => c.AuthLayoutComponent),
        resolve: {
          currentUser: () => {
            return inject(CurrentUserService).fetchCurrentUser$('admin/me');
          },
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@tnq/shared/ui').then((c) => c.NavLayoutComponent),
            children: [
              {
                path: 'admins',
                loadChildren: () =>
                  import('@tnq/admin/admins').then((c) => c.adminsRoutes),
              },
              {
                path: 'customers',
                loadChildren: () =>
                  import('@tnq/admin/customers').then((c) => c.customerRoutes),
              },
              {
                path: 'customer-groups',
                loadChildren: () =>
                  import('@tnq/admin/customer-groups').then(
                    (c) => c.customerGroupsRoutes,
                  ),
              },
              {
                path: 'kortingen',
                loadChildren: () =>
                  import('@tnq/admin/discounts').then((c) => c.discountsRoutes),
              },
              {
                path: 'station-groups',
                canActivate: [
                  roleGuard([AdminRole.SuperAdmin], 'admins', 'admin/me'),
                ],
                loadChildren: () =>
                  import('@tnq/admin/station-groups').then(
                    (c) => c.stationGroupsRoutes,
                  ),
              },
              {
                path: 'audit-log',
                canActivate: [
                  roleGuard([AdminRole.SuperAdmin], 'admins', 'admin/me'),
                ],
                loadChildren: () =>
                  import('@tnq/admin/audit-log').then((c) => c.auditLogRoutes),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('@tnq/admin/auth').then((c) => c.authRoutes),
  },
];
